import React, { Component } from 'react';

export default class GiftIExtended extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {rowData} = this.props;
	let extended ;
	if(rowData.iExtended == 0){
		extended = null;
	}else{
		if(rowData.iExtendedRule == 2){
			extended = '购买全部项';
		}else{
			extended = '购买任意'+ rowData.iSpecies +'项';
		}
	}
    return (
      <div className='gift-extended'>
          <p className='gift-extended-p'>{extended}</p>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/common/components/formatter/GiftIExtended.jsx